import React, { Component } from "react";
import { Icon, Image, Menu } from "semantic-ui-react";
import { UserContext } from "context/userProvider";
import "scss/components/Navigation.scss";
import { Navigate } from "react-router-dom";

export default class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeItem: "home",
    };
  }

  handleItemClick = (e, { name }) => this.setState({ activeItem: name });
  render() {
    const { activeItem } = this.state;
    return (
      <header className="navigation">
        {console.log(this.context.userDetail)}
        {this.context.userDetail?.length === 0 && <Navigate to="/" />}
        <Menu>
          <Menu.Item name="logo">
            <span>
              <b>CLP KASET ADMINISTRATOR</b>
            </span>
          </Menu.Item>
          <Menu.Menu position="right">
            <Menu.Item
              name="user"
              active={activeItem === "user"}
              onClick={this.handleItemClick}>
              <Image
                avatar
                spaced="right"
                src="https://react.semantic-ui.com/images/avatar/small/elliot.jpg"/>
              {this.context.userDetail?.firstname}
            </Menu.Item>
            <Menu.Item
              name="logout"
              active={activeItem === "logout"}
              href="/"
              onClick={(e) => this.context.logoutClp()}>
              <Icon name="sign-out" />
              ออกจากระบบ
            </Menu.Item>
          </Menu.Menu>
        </Menu>
      </header>
    );
  }
}

Navigation.contextType = UserContext;
